import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Marketing from "@/pages/Marketing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import PMDashboard from "@/pages/pm/PMDashboard";
import VendorDashboard from "@/pages/vendor/VendorDashboard";
import WorkOrderDetail from "@/pages/WorkOrderDetail";

function HomeGate() {
  const { user } = useAuth();
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;
  if (user && user.role === "pm") return <Navigate to="/pm" replace />;
  if (user && user.role === "vendor") return <Navigate to="/vendor" replace />;
  return <Marketing />;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeGate />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/pm" element={<ProtectedRoute roles={["pm"]}><PMDashboard /></ProtectedRoute>} />
          <Route path="/vendor" element={<ProtectedRoute roles={["vendor"]}><VendorDashboard /></ProtectedRoute>} />
          <Route path="/orders/:id" element={<ProtectedRoute><WorkOrderDetail /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
